import { Space, Modal, Button } from 'antd';
import { useDialog, useMessagesAPI } from '~/hooks';
import { atom } from 'jotai';
import { CopyOutlined } from '@ant-design/icons';
import { PurchaseSubscriptionButton } from '../AiHelpersGrid';
import copy from 'copy-to-clipboard';

const subscriptionPromotionModal = atom(false);

export function useSubscriptionPromotionModal() {
    return useDialog(subscriptionPromotionModal);
}

export default function SubscriptionPromotionModal({
    navigateToAccountTab,
    account,
}) {
    const { isOpened, closeDialog } = useSubscriptionPromotionModal();
    const messageApi = useMessagesAPI();

    if (!account) {
        return null;
    }

    const refCode = account.refCode.toUpperCase();
    function handleCopyToClipboard(str: string) {
        if (!str) {
            return;
        }
        copy(str, { format: 'text/plain' });
        messageApi?.info(`Your referral code "${str}" copied to clipboard`);
    }

    return (
        <Modal
            centered
            open={isOpened}
            destroyOnClose={true}
            onOk={() => {}}
            onCancel={closeDialog}
            footer={null}>
            <div className='flex w-full flex-col items-center justify-center'>
                <h2 className='py-4 text-center text-2xl'> 👻 Out of Tokens</h2>
                <p className='text-left w-full'>
                    You have used up all your tokens. Get <b>100 tokens</b> for
                    each friend you invite or purchase a subscription.
                </p>
                <Space wrap className='my-4 justify-center items-center'>
                    <Button
                        size='large'
                        icon={<CopyOutlined />}
                        type='dashed'
                        onClick={() => handleCopyToClipboard(refCode)}>
                        Copy Your Referral Code
                    </Button>
                    <PurchaseSubscriptionButton />
                </Space>
                <div className='flex flex-col items-center justify-start w-full mt-4'>
                    <span>Got a friend’s referral code?</span>
                    <Button
                        type='link'
                        className='!p-0'
                        onClick={() => {
                            navigateToAccountTab();
                            closeDialog();
                        }}>
                        You can activate it on the Account tab
                    </Button>
                </div>
            </div>
        </Modal>
    );
}
